export default __webpack_public_path__ + "static/media/memetican.bcb91986.png";